import { render, staticRenderFns } from "./TextRow.vue?vue&type=template&id=4cc18dcc"
import script from "./TextRow.vue?vue&type=script&lang=js"
export * from "./TextRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports